import React, { useRef } from 'react';
import Button from '../Button';
import {
  UrlType,
  useStripeCustomerPortal,
} from 'src/hooks/useStripeCustomerPortal';
import * as S from './style';

type Props = {
  children: React.ReactNode;
};

export function CustomerPortalButton({ children }: Props) {
  const linkRef = useRef<HTMLAnchorElement | null>(null);
  const { portalUrl } = useStripeCustomerPortal(UrlType.ADMIN_URL);

  return (
    <S.Container>
      <Button
        disabled={!portalUrl}
        onClick={() => {
          linkRef.current?.click();
        }}
        style={{ position: 'relative' }}
      >
        {children}
      </Button>
      {!portalUrl && <S.LoadingIcon />}
      <a hidden={true} target="_top" ref={linkRef} href={portalUrl}>
        Link to portal
      </a>
    </S.Container>
  );
}
